'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.lang language (en, fr, etc..)
     * @param {string} params.cntry country
     * @param {number} params.radius radius in miles
     * @param {string} params.address zip or city, state
     * @returns {Bluebird Promise}
     */
    save: function save(params, data) {
        return this.postApiRequest(this.getUrl().autoReloadSave, params, data);
    },
    get: function get(params, data) {
        return this.postApiRequest(this.getUrl().autoReloadGet, params, data);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/autoReloadClient.js
// module id = 777
// module chunks = 0